module.exports = __webpack_public_path__ + "img/box9-23.08e0ec49.png";